import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const DeleteRateModal = ({ isOpen, onClose, onConfirm, rate }) => {
  if (!rate) return null;

  const bodyMessage = `Are you sure you want to delete the kilometer rate "<strong>${rate.rate_per_km}</strong>"? This action cannot be undone.`;

  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Confirm Delete"
      bodyMessage={<div dangerouslySetInnerHTML={{ __html: bodyMessage }} />}
      confirmLabel="Delete"
      cancelLabel="Cancel"
    />
  );
};

export default DeleteRateModal;
